(function(){
  const root = document.getElementById('coHomeApp');
  if(!root) return;

  const stage = root.querySelector('[data-co-stage]');
  const progress = root.querySelector('[data-co-progress]');
  const resetBtn = root.querySelector('[data-co-reset]');

  const state = {
    screen: 'home',
    path: null,
    index: 0,
    answers: {},
    history: []
  };

  const paths = {
    mortgage: {
      label: 'Mortgage Readiness',
      short: 'Mortgage',
      icon: '🏠',
      color: '#102033',
      glow: 'rgba(16,32,51,.16)',
      intro: 'Check timing, payment-history, balances, and recent credit activity before applying.',
      scanLines: ['Reviewing mortgage timing…','Checking payment-history signals…','Scanning balance pressure…','Preparing your mortgage snapshot…'],
      questions: [
        {
          id: 'timeframe',
          title: 'When are you hoping to apply for a mortgage?',
          sub: 'Timing matters because certain credit changes can matter more when you are close to applying.',
          options: [
            { label:'Within 30 days', value:'soon', weight:{newCredit:1} },
            { label:'1–3 months', value:'medium', weight:{} },
            { label:'3–6 months', value:'later', weight:{} },
            { label:'Just preparing', value:'prep', weight:{} }
          ]
        },
        {
          id: 'mortgageLate',
          title: 'Any mortgage late payment in the last 12 months?',
          sub: 'A recent mortgage late is one of the strongest readiness signals to review before applying.',
          options: [
            { label:'Yes', value:'yes', weight:{paymentHistory:3} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure / need to check', value:'unsure', weight:{paymentHistory:1} }
          ]
        },
        {
          id: 'balances',
          title: 'Are your credit cards reporting balances?',
          sub: 'Several cards reporting balances can create pressure before a lender reviews your file.',
          options: [
            { label:'Yes, several cards', value:'several', weight:{balancePressure:2} },
            { label:'Yes, one or two cards', value:'some', weight:{balancePressure:1} },
            { label:'No / mostly zero', value:'low', weight:{} },
            { label:'Not sure', value:'unsure', weight:{balancePressure:1} }
          ]
        },
        {
          id: 'recentCredit',
          title: 'Any recent inquiries or new accounts?',
          sub: 'New credit activity can be worth reviewing before mortgage shopping.',
          options: [
            { label:'Yes, within 30 days', value:'30', weight:{newCredit:2} },
            { label:'Yes, within 3–6 months', value:'180', weight:{newCredit:1} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{newCredit:1} }
          ]
        }
      ]
    },

    auto: {
      label: 'Auto Loan Readiness',
      short: 'Auto Loan',
      icon: '🚗',
      color: '#102033',
      glow: 'rgba(16,32,51,.16)',
      intro: 'Check auto payment history, recent applications, and balance pressure before shopping.',
      scanLines: ['Reviewing auto-loan timing…','Checking auto payment signals…','Scanning recent credit shopping…','Preparing your auto snapshot…'],
      questions: [
        {
          id: 'autoTimeframe',
          title: 'When are you planning to shop for an auto loan?',
          sub: 'If you are shopping soon, the order of what you check matters more.',
          options: [
            { label:'This week', value:'week', weight:{newCredit:1} },
            { label:'Within 30 days', value:'30', weight:{} },
            { label:'1–3 months', value:'90', weight:{} },
            { label:'Just preparing', value:'prep', weight:{} }
          ]
        },
        {
          id: 'autoLate',
          title: 'Any late payment on an auto loan or lease?',
          sub: 'Auto lenders may pay close attention to prior auto payment history.',
          options: [
            { label:'Yes, within 12 months', value:'recent', weight:{paymentHistory:3} },
            { label:'Yes, more than 12 months ago', value:'older', weight:{paymentHistory:1} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{paymentHistory:1} }
          ]
        },
        {
          id: 'autoInquiries',
          title: 'Have you recently applied for auto financing?',
          sub: 'Multiple recent applications may be normal when rate-shopping, but still worth understanding.',
          options: [
            { label:'Yes, multiple places', value:'multiple', weight:{newCredit:2} },
            { label:'Yes, one place', value:'one', weight:{newCredit:1} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{newCredit:1} }
          ]
        },
        {
          id: 'autoBalances',
          title: 'Are your credit cards carrying balances?',
          sub: 'Card balances can affect how your overall credit profile looks before financing.',
          options: [
            { label:'Yes, several cards', value:'several', weight:{balancePressure:2} },
            { label:'Yes, one or two cards', value:'some', weight:{balancePressure:1} },
            { label:'No / mostly zero', value:'low', weight:{} },
            { label:'Not sure', value:'unsure', weight:{balancePressure:1} }
          ]
        }
      ]
    },

    cards: {
      label: 'Credit Card Approval',
      short: 'Card Approval',
      icon: '💳',
      color: '#102033',
      glow: 'rgba(16,32,51,.16)',
      intro: 'Check utilization, card balances, line changes, and approval-readiness signals.',
      scanLines: ['Reviewing card-approval signals…','Checking utilization pressure…','Scanning limit-change risk…','Preparing your card snapshot…'],
      questions: [
        {
          id: 'cardGoal',
          title: 'What are you trying to do?',
          sub: 'Different card goals can be affected by different credit signals.',
          options: [
            { label:'Get approved for a new card', value:'new', weight:{newCredit:1} },
            { label:'Get a higher limit', value:'increase', weight:{balancePressure:1} },
            { label:'Avoid a credit-line cut', value:'avoid_cut', weight:{limitRisk:1} },
            { label:'Not sure', value:'unsure', weight:{} }
          ]
        },
        {
          id: 'cardsReporting',
          title: 'How many cards are reporting balances?',
          sub: 'The number of cards with balances can matter, not just the total amount owed.',
          options: [
            { label:'Most of them', value:'most', weight:{balancePressure:3} },
            { label:'A few', value:'few', weight:{balancePressure:2} },
            { label:'One', value:'one', weight:{balancePressure:1} },
            { label:'None / mostly zero', value:'none', weight:{} }
          ]
        },
        {
          id: 'nearLimit',
          title: 'Are any cards close to the limit?',
          sub: 'A single high-balance card can create pressure even if other cards are lower.',
          options: [
            { label:'Yes', value:'yes', weight:{balancePressure:3} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{balancePressure:1} }
          ]
        },
        {
          id: 'limitChange',
          title: 'Have any limits been lowered or cards closed recently?',
          sub: 'Limit cuts and closures can change your utilization even if you did not spend more.',
          options: [
            { label:'Yes', value:'yes', weight:{limitRisk:3} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{limitRisk:1} }
          ]
        }
      ]
    },

    score: {
      label: 'Score Dropped / Something Changed',
      short: 'Score Change',
      icon: '⚡',
      color: '#102033',
      glow: 'rgba(16,32,51,.16)',
      intro: 'Check reporting timing, balance changes, account changes, and unknown activity.',
      scanLines: ['Reviewing recent score movement…','Checking reporting timing…','Scanning account-change signals…','Preparing your score-change snapshot…'],
      questions: [
        {
          id: 'whatHappened',
          title: 'What happened with your score?',
          sub: 'Start with the change you noticed. The next signals can help narrow where to look.',
          options: [
            { label:'Dropped after paying balances', value:'paid_drop', weight:{reportingTiming:3} },
            { label:'Dropped and I do not know why', value:'unknown', weight:{identitySignal:1, reportingTiming:1} },
            { label:'New negative item appeared', value:'negative', weight:{negativeRisk:3} },
            { label:'Something changed but I am not sure', value:'unsure', weight:{identitySignal:1} }
          ]
        },
        {
          id: 'usedAgain',
          title: 'Did you use a card again after paying it down?',
          sub: 'Sometimes the balance that reports is not the balance you expected.',
          options: [
            { label:'Yes', value:'yes', weight:{reportingTiming:2} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{reportingTiming:1} }
          ]
        },
        {
          id: 'reportingDate',
          title: 'Do you know when your cards report balances?',
          sub: 'Payment date and reporting date are not always the same thing.',
          options: [
            { label:'Yes', value:'yes', weight:{} },
            { label:'No', value:'no', weight:{reportingTiming:2} },
            { label:'Not sure', value:'unsure', weight:{reportingTiming:1} }
          ]
        },
        {
          id: 'recognizeActivity',
          title: 'Do you recognize all accounts and inquiries?',
          sub: 'Unknown accounts or inquiries should be checked before assuming it is only a score issue.',
          options: [
            { label:'Yes', value:'yes', weight:{} },
            { label:'No', value:'no', weight:{identitySignal:3} },
            { label:'Not sure', value:'unsure', weight:{identitySignal:1} }
          ]
        }
      ]
    },

    build: {
      label: 'Build or Rebuild Credit',
      short: 'Build Credit',
      icon: '🌱',
      color: '#102033',
      glow: 'rgba(16,32,51,.16)',
      intro: 'Check credit depth, open accounts, negative history, and the best next area to review.',
      scanLines: ['Reviewing credit-depth signals…','Checking positive-account base…','Scanning rebuild risk…','Preparing your build-credit snapshot…'],
      questions: [
        {
          id: 'buildSituation',
          title: 'What best describes your credit situation?',
          sub: 'Building credit is different from rebuilding after past problems.',
          options: [
            { label:'I am new to credit', value:'new', weight:{creditDepth:3} },
            { label:'I have limited history', value:'thin', weight:{creditDepth:2} },
            { label:'I had past credit problems', value:'past', weight:{negativeRisk:2} },
            { label:'Rebuilding after collections/late payments', value:'rebuild', weight:{negativeRisk:3} }
          ]
        },
        {
          id: 'openAccounts',
          title: 'Do you currently have open credit cards or loans?',
          sub: 'A positive account base is often part of building a stronger file over time.',
          options: [
            { label:'Yes, credit card', value:'card', weight:{} },
            { label:'Yes, loan', value:'loan', weight:{} },
            { label:'Yes, both', value:'both', weight:{} },
            { label:'No open accounts', value:'none', weight:{creditDepth:3} }
          ]
        },
        {
          id: 'negativeHistory',
          title: 'Are any accounts reporting negative history?',
          sub: 'Negative history can change the best next step for rebuilding.',
          options: [
            { label:'Yes', value:'yes', weight:{negativeRisk:3} },
            { label:'No', value:'no', weight:{} },
            { label:'Not sure', value:'unsure', weight:{negativeRisk:1} }
          ]
        },
        {
          id: 'buildGoal',
          title: 'What is your main goal?',
          sub: 'Your next step should match the reason you are trying to build credit.',
          options: [
            { label:'Get approved for a card', value:'card', weight:{newCredit:1} },
            { label:'Prepare for auto loan', value:'auto', weight:{} },
            { label:'Prepare for mortgage later', value:'mortgage', weight:{} },
            { label:'Raise my score generally', value:'score', weight:{} }
          ]
        }
      ]
    }
  };

  const signalLabels = {
    paymentHistory: 'Payment History',
    balancePressure: 'Balance Pressure',
    newCredit: 'New Credit Activity',
    limitRisk: 'Limit Cut / Closure Risk',
    reportingTiming: 'Reporting Timing',
    identitySignal: 'Unknown Activity Signal',
    negativeRisk: 'Negative Activity',
    creditDepth: 'Credit Depth'
  };

  function setTheme(pathKey){
    const p = paths[pathKey] || paths.mortgage;
    root.style.setProperty('--path-color', p.color);
    if(progress) progress.style.background = 'linear-gradient(90deg, #102033, #2E5A46)';
  }

  function setProgress(value){
    if(progress) progress.style.width = `${Math.max(0, Math.min(100, value))}%`;
  }

  function pushHistory(){
    state.history.push(JSON.stringify({
      screen: state.screen,
      path: state.path,
      index: state.index,
      answers: state.answers
    }));
  }

  function goBack(){
    const last = state.history.pop();
    if(!last) return renderHome();
    const prev = JSON.parse(last);
    state.screen = prev.screen;
    state.path = prev.path;
    state.index = prev.index;
    state.answers = prev.answers || {};
    render();
  }

  function renderHome(){
    state.screen = 'home';
    state.path = null;
    state.index = 0;
    state.answers = {};
    state.history = [];
    setProgress(0);
    root.style.setProperty('--path-color', '#102033');
    if(resetBtn) resetBtn.style.display = 'none';

    const tiles = Object.entries(paths).map(([key,p]) => `
      <button class="co-path-card" type="button" data-path="${key}" style="--tile-color:${p.color};--tile-glow:${p.glow};">
        <div class="co-path-icon">${p.icon}</div>
        <div>
          <h3>${p.label}</h3>
          <p>${p.intro}</p>
          <strong>Begin snapshot →</strong>
        </div>
      </button>
    `).join('');

    stage.innerHTML = `
      <div class="co-screen">
        <div class="co-path-grid">${tiles}</div>
      </div>
    `;

    stage.querySelectorAll('[data-path]').forEach(btn => {
      btn.addEventListener('click', () => {
        pushHistory();
        state.path = btn.getAttribute('data-path');
        state.screen = 'question';
        state.index = 0;
        setTheme(state.path);
        if(resetBtn) resetBtn.style.display = 'inline-flex';
        render();
      });
    });
  }

  function renderQuestion(){
    const p = paths[state.path];
    setTheme(state.path);
    if(resetBtn) resetBtn.style.display = 'inline-flex';

    const q = p.questions[state.index];
    const pct = 12 + ((state.index) / p.questions.length) * 58;
    setProgress(pct);

    const answers = q.options.map(opt => `
      <button type="button" class="co-answer-btn" data-answer='${escapeAttr(JSON.stringify(opt))}'>
        <span>${opt.label}</span>
        <span class="co-answer-arrow">→</span>
      </button>
    `).join('');

    stage.innerHTML = `
      <div class="co-screen co-question-shell">
        <div class="co-question-top">
          <button class="co-back-btn" type="button" data-back>← Back</button>
          <div class="co-step-pill">${p.icon} ${p.short} • ${state.index + 1} of ${p.questions.length}</div>
        </div>
        <h3>${q.title}</h3>
        <p>${q.sub}</p>
        <div class="co-answer-grid">${answers}</div>
      </div>
    `;

    stage.querySelector('[data-back]').addEventListener('click', goBack);
    stage.querySelectorAll('[data-answer]').forEach(btn => {
      btn.addEventListener('click', () => {
        const opt = JSON.parse(btn.getAttribute('data-answer'));
        pushHistory();
        state.answers[q.id] = opt;

        if(state.index < p.questions.length - 1){
          state.index += 1;
          renderQuestion();
        } else {
          state.screen = 'scan';
          renderScan();
        }
      });
    });
  }

  function renderScan(){
    const p = paths[state.path];
    setTheme(state.path);
    setProgress(82);
    if(resetBtn) resetBtn.style.display = 'inline-flex';

    stage.innerHTML = `
      <div class="co-screen co-scan">
        <div class="co-scan-core">
          <div class="co-scan-symbol">${p.icon}</div>
        </div>
        <h3>Preparing your credit snapshot…</h3>
        <div class="co-scan-lines">
          ${p.scanLines.map((line,i) => `
            <div class="co-scan-line" data-scan-line style="transition-delay:${i * 70}ms">
              <span class="co-scan-dot"></span>
              <span>${line}</span>
            </div>
          `).join('')}
        </div>
      </div>
    `;

    const lines = Array.from(stage.querySelectorAll('[data-scan-line]'));
    lines.forEach((line, i) => {
      setTimeout(() => line.classList.add('is-active'), 260 + i * 520);
    });

    setTimeout(() => {
      state.screen = 'result';
      renderResult();
    }, 2850);
  }

  function calculateSignals(){
    const totals = {};

    Object.values(state.answers).forEach(answer => {
      const weight = answer.weight || {};
      Object.keys(weight).forEach(k => {
        totals[k] = (totals[k] || 0) + weight[k];
      });
    });

    const pathDefaultSignals = {
      mortgage: ['paymentHistory','balancePressure','newCredit'],
      auto: ['paymentHistory','newCredit','balancePressure'],
      cards: ['balancePressure','limitRisk','newCredit'],
      score: ['reportingTiming','identitySignal','negativeRisk'],
      build: ['creditDepth','negativeRisk','newCredit']
    };

    const keys = Array.from(new Set([...(pathDefaultSignals[state.path] || []), ...Object.keys(totals)]));

    return keys.map(key => {
      const score = totals[key] || 0;
      let status = 'green';
      let tag = 'Clear';

      if(score >= 3){
        status = 'red';
        tag = 'Review first';
      } else if(score >= 1){
        status = 'orange';
        tag = 'Worth checking';
      }

      return {
        key,
        label: signalLabels[key] || key,
        score,
        status,
        tag,
        message: getSignalMessage(key, status)
      };
    }).sort((a,b) => b.score - a.score);
  }

  function getSignalMessage(key, status){
    const messages = {
      paymentHistory: {
        red:'Recent payment history may need review before moving forward.',
        orange:'Payment history is worth checking before your next credit move.',
        green:'No major payment-history signal was indicated by your answers.'
      },
      balancePressure: {
        red:'Balances may be creating pressure in the way your file appears.',
        orange:'Card balances may be worth checking before applying.',
        green:'No major balance-pressure signal was indicated.'
      },
      newCredit: {
        red:'Recent applications or new accounts may need review.',
        orange:'New credit activity may be a watch area.',
        green:'No major new-credit signal was indicated.'
      },
      limitRisk: {
        red:'A limit cut or closure may be affecting utilization or approval readiness.',
        orange:'Limit changes may be worth checking.',
        green:'No major limit-change signal was indicated.'
      },
      reportingTiming: {
        red:'Reporting timing may explain why your score reacted differently than expected.',
        orange:'Payment timing and reporting dates may be worth checking.',
        green:'No major reporting-timing signal was indicated.'
      },
      identitySignal: {
        red:'Unknown accounts or inquiries should be reviewed carefully.',
        orange:'Unrecognized activity may be worth checking.',
        green:'No unknown-activity signal was indicated.'
      },
      negativeRisk: {
        red:'Recent negative activity may need review before your next step.',
        orange:'Negative-history signals may be worth checking.',
        green:'No major negative-activity signal was indicated.'
      },
      creditDepth: {
        red:'Your file may need a stronger positive account base over time.',
        orange:'Credit depth may be a factor to strengthen.',
        green:'No major credit-depth concern was indicated.'
      }
    };

    return (messages[key] && messages[key][status]) || 'This area may be worth checking.';
  }

  function getResultHeadline(pathKey, issueCount){
    const hasIssues = issueCount > 0;

    const map = {
      mortgage: hasIssues
        ? 'Your mortgage readiness snapshot found a few areas worth reviewing.'
        : 'Your mortgage readiness snapshot looks relatively stable.',
      auto: hasIssues
        ? 'Your auto financing snapshot found a few areas worth reviewing.'
        : 'Your auto financing snapshot looks relatively stable.',
      cards: hasIssues
        ? 'Your card approval snapshot found a few areas worth reviewing.'
        : 'Your card approval snapshot looks relatively stable.',
      score: hasIssues
        ? 'Your answers point to a few areas that may explain the change.'
        : 'No major explanation was detected from the answers provided.',
      build: hasIssues
        ? 'Your credit-building snapshot found a few areas to strengthen.'
        : 'Your credit-building foundation appears relatively stable.'
    };

    return map[pathKey] || (hasIssues
      ? 'Your snapshot found a few areas worth reviewing.'
      : 'Your answers look relatively stable.');
  }

  function getCTA(pathKey){
    const map = {
      mortgage: 'View My Mortgage Checklist',
      auto: 'View My Auto Readiness Checklist',
      cards: 'View My Card Approval Checklist',
      score: 'View My Credit Snapshot',
      build: 'View My Credit Building Checklist'
    };

    return map[pathKey] || 'View My Personalized Checklist';
  }

  function renderResult(){
    const p = paths[state.path];
    const signals = calculateSignals();
    const issueCount = signals.filter(s => s.status !== 'green').length;
    setTheme(state.path);
    setProgress(100);
    if(resetBtn) resetBtn.style.display = 'inline-flex';

    const signalRows = signals.map((s,i) => `
      <div class="co-signal-row" style="animation-delay:${i * 90}ms">
        <span class="co-status-dot co-status-${s.status}"></span>
        <div>
          <div class="co-signal-name">${s.label}</div>
          <div class="co-signal-msg">${s.message}</div>
        </div>
        <span class="co-signal-tag">${s.tag}</span>
      </div>
    `).join('');

    const headline = getResultHeadline(state.path, issueCount);
    const nextItems = getNextItems(state.path, signals);
    const ctaText = getCTA(state.path);

    stage.innerHTML = `
      <div class="co-screen co-result">
        <div class="co-result-head">
          <div class="co-result-kicker"><span></span> ${p.label} Snapshot</div>
          <h3>${headline}</h3>
          <p>This is a quick educational snapshot based on your answer pattern. It shows where to look first, not a full credit report review.</p>
        </div>

        <div class="co-result-grid">
          <div class="co-signal-card">
            <div class="co-card-label">Signal detection</div>
            <div class="co-signal-list">${signalRows}</div>
          </div>

          <div class="co-next-card">
            <div class="co-card-label">What this means</div>
            <h3>Your next step is to verify the right areas before guessing.</h3>
            <p>A checklist can turn this snapshot into a clearer review path with what to check first and what to avoid for your goal.</p>

            <div class="co-mini-list">
              ${nextItems.map(item => `<div class="co-mini-item"><span class="co-mini-check">✓</span><span>${item}</span></div>`).join('')}
            </div>

            <button class="co-main-cta" type="button" data-placeholder-cta>${ctaText}</button>
            <button class="co-soft-link" type="button" data-back>Change my answers</button>
          </div>
        </div>
      </div>
    `;

    stage.querySelector('[data-back]').addEventListener('click', () => {
      pushHistory();
      state.screen = 'question';
      state.index = paths[state.path].questions.length - 1;
      renderQuestion();
    });

    stage.querySelector('[data-placeholder-cta]').addEventListener('click', () => {
      alert('Placeholder: connect this button later to the paid checklist page or checkout.');
    });
  }

  function getNextItems(pathKey, signals){
    const risky = signals.filter(s => s.status !== 'green').slice(0,2).map(s => s.label.toLowerCase());
    const first = risky.length ? `Start by checking ${risky.join(' and ')}.` : 'Keep checking the core areas before applying.';

    const map = {
      mortgage: [first, 'Avoid unnecessary new credit before mortgage review.', 'Check balances and payment history before applying.'],
      auto: [first, 'Review recent auto applications or inquiries.', 'Check balances before shopping for financing.'],
      cards: [first, 'Review utilization and card limits before applying.', 'Check for recent limit cuts or closures.'],
      score: [first, 'Compare payment date versus reporting date.', 'Verify unfamiliar accounts or inquiries quickly.'],
      build: [first, 'Focus on building a stronger positive account base.', 'Avoid over-applying before your next step is clear.']
    };

    return map[pathKey] || [first, 'Review the areas flagged in your snapshot.', 'Use the next checklist to verify what matters most.'];
  }

  function render(){
    if(state.screen === 'home') return renderHome();
    if(state.screen === 'question') return renderQuestion();
    if(state.screen === 'scan') return renderScan();
    if(state.screen === 'result') return renderResult();
  }

  function escapeAttr(str){
    return String(str)
      .replace(/&/g,'&amp;')
      .replace(/'/g,'&#39;')
      .replace(/"/g,'&quot;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;');
  }

  if(resetBtn) resetBtn.addEventListener('click', renderHome);
  renderHome();


  function initSupportWidget(){
    if(document.querySelector('.co-support-widget')) return;

    const hiddenPaths = ['/checkout', '/cart', '/thank-you', '/success'];
    const currentPath = window.location.pathname.toLowerCase();
    if(hiddenPaths.some(path => currentPath.includes(path))) return;

    const charlesPhotoUrl = "https://cdn.shopify.com/s/files/1/0784/3820/3605/files/ChatGPT_Image_May_31_2026_08_53_44_PM.png?v=1780275324";
    const melissaPhotoUrl = "https://cdn.shopify.com/s/files/1/0784/3820/3605/files/ChatGPT_Image_May_31_2026_08_52_42_PM.png?v=1780275348";

    const agents = [
      {
        key: 'charles',
        name: 'Charles Anderson',
        role: 'Credit Optimize Support',
        intro: "Hi, I’m Charles from Credit Optimize. Have a question before you begin? Send it here and we’ll get back to you."
      },
      {
        key: 'melissa',
        name: 'Melissa Rogers',
        role: 'Client Experience',
        intro: "Hi, I’m Melissa from Credit Optimize. Have a question before you begin? Send it here and we’ll get back to you."
      }
    ];

    const savedIndex = Number(localStorage.getItem('coSupportAgentIndex') || '0');
    const agentIndex = Number.isFinite(savedIndex) ? savedIndex % agents.length : 0;
    const agent = agents[agentIndex];

    localStorage.setItem('coSupportAgentIndex', String((agentIndex + 1) % agents.length));

    const widget = document.createElement('div');
    widget.className = 'co-support-widget';
    widget.style.setProperty('--charles-url', 'url("' + charlesPhotoUrl + '")');
    widget.style.setProperty('--melissa-url', 'url("' + melissaPhotoUrl + '")');

    widget.innerHTML = `
      <button class="co-support-launcher" type="button" aria-label="Ask Credit Optimize a question" data-co-support-open>
        <span class="co-support-avatar-stack" aria-hidden="true">
          <span class="co-support-avatar charles"></span>
          <span class="co-support-avatar melissa"></span>
        </span>
        <span class="co-support-launch-text">
          <strong>Questions?</strong>
          <span>Ask Credit Optimize</span>
        </span>
      </button>

      <div class="co-support-panel" role="dialog" aria-label="Credit Optimize support question box">
        <div class="co-support-header">
          <div class="co-support-agent-photo ${agent.key}" aria-hidden="true"></div>
          <div class="co-support-agent-meta">
            <strong>${agent.name}</strong>
            <span>${agent.role}</span>
          </div>
          <button class="co-support-close" type="button" aria-label="Close support box" data-co-support-close>×</button>
        </div>

        <div class="co-support-body">
          <div class="co-support-bubble">${agent.intro}</div>

          <div class="co-support-offer-note">
            The personalized checklist is currently planned as a $47 unlock after the free snapshot.
          </div>

          <form class="co-support-form" data-co-support-form>
            <input class="co-support-input" type="text" name="name" placeholder="Your name" autocomplete="name">
            <input class="co-support-input" type="email" name="email" placeholder="Email address" autocomplete="email">
            <textarea class="co-support-textarea" name="message" placeholder="What would you like to ask?"></textarea>
            <button class="co-support-submit" type="submit">Send Question</button>
            <p class="co-support-note">Please do not send SSNs, passwords, or sensitive account details.</p>
          </form>

          <div class="co-support-success">
            Thanks — your question has been captured. Connect this form to your email/SMS provider next so messages reach you automatically.
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(widget);

    const openBtn = widget.querySelector('[data-co-support-open]');
    const closeBtn = widget.querySelector('[data-co-support-close]');
    const form = widget.querySelector('[data-co-support-form]');

    openBtn.addEventListener('click', () => {
      widget.classList.toggle('is-open');
    });

    closeBtn.addEventListener('click', () => {
      widget.classList.remove('is-open');
    });

    document.addEventListener('keydown', (event) => {
      if(event.key === 'Escape') widget.classList.remove('is-open');
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const data = new FormData(form);
      const payload = {
        name: (data.get('name') || '').toString().trim(),
        email: (data.get('email') || '').toString().trim(),
        message: (data.get('message') || '').toString().trim(),
        agent: agent.name,
        source: 'Credit Optimize support widget',
        page: window.location.href,
        createdAt: new Date().toISOString()
      };

      try {
        const existing = JSON.parse(localStorage.getItem('coSupportMessages') || '[]');
        existing.push(payload);
        localStorage.setItem('coSupportMessages', JSON.stringify(existing.slice(-25)));
      } catch(error) {
        console.warn('Credit Optimize support widget storage error:', error);
      }

      widget.classList.add('is-sent');
    });
  }

  initSupportWidget();

})();